import { Stack, Box, CardContent, styled, Typography, Card } from '@mui/material';
import { convertNumberIntoCurrency } from '../../../components/Utilities/HelperMethods';

const StyledIMOCard = styled(Card)(({ theme }) => ({
  minWidth: '200px',
  background: theme.palette.grey['100'],
  [theme.breakpoints.down('md')]: {
    flex: 1,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const StyledIMOBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '1rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const HeaderStack = ({ cards }) => {
  return (
    <Stack spacing={1}>
      <Typography>Summary</Typography>
      <StyledIMOBox>
        {cards.map((card, i) => (
          <StyledIMOCard key={`${card.label}-${i}`}>
            <CardContent>
              <Typography variant="caption">{card.label}</Typography>
              <Typography variant="subtitle1">
                {card.currency ? convertNumberIntoCurrency(card.field) : card.field}
              </Typography>
            </CardContent>
          </StyledIMOCard>
        ))}
      </StyledIMOBox>
    </Stack>
  );
};

export default HeaderStack;
